<script>
import { checkPermission, handleResponseError, shouldShowTooltip } from '@/components/utils/globalFunction'
import SelectStoreModal from '@/components/modal/repair-file/SelectStoreModal.vue'
import RecyclingFolderService from '@/services/recyclingModule/RecyclingFolderService'
import ManufacturerService from '@/services/referentiel/ManufacturerService'

export default {
  name: 'recyclingReportPage',
  components: { SelectStoreModal },
  data() {
    return {
      loading: false,

      storeList: [],
      selectedStore: [],

      manufacturerList: [],
      selectedManufacturer: [],

      reportObject: null,
      reportAllIndexObject: null
    }
  },
  async mounted() {
    this.storeList = this.$store.getters['auth/getStoreListCollaborator']
    if (this.storeList.length === 1) {
      this.selectedStore.push(this.storeList[0])
    } else {
      this.selectedStore = []
    }

    if (this.selectedStore.length > 0) {
      this.manufacturerList = await this.getManufacturerListByStoreList(this.selectedStore.technical_id)
    } else {
      this.manufacturerList = []
    }
  },
  watch: {
    async selectedStore() {
      this.selectedManufacturer = []

      if (this.selectedStore.length > 0) {
        await this.getManufacturerListByStoreList()

        await this.getRecyclingReport()
        await this.getRecyclingReportAllIndex()
      } else {
        this.manufacturerList = []
        this.reportObject = null
        this.reportAllIndexObject = null
      }
    },
    async selectedManufacturer() {
      if (this.selectedManufacturer.length > 0) {
        await this.getRecyclingReport()
        await this.getRecyclingReportAllIndex()
      }
    }
  },
  computed: {},
  methods: {
    shouldShowTooltip,
    checkPermission,
    async getManufacturerListByStoreList() {
      try {
        const storeIdList = this.selectedStore.map(store => store.technical_id)
        const response = await ManufacturerService.getManufacturerListByStoreList(storeIdList)
        this.manufacturerList = response.item_list
      } catch (error) {
        handleResponseError(error)
      }
    },
    async getRecyclingReport() {
      try {
        const storeIdList = this.selectedStore.map(store => store.technical_id)
        let manufacturerIdList = []
        if (this.selectedManufacturer.length > 0) {
          manufacturerIdList = this.selectedManufacturer.map(manufacturer => manufacturer.technical_id)
        }

        this.reportObject = await RecyclingFolderService.getRecyclingFolderFullReport(storeIdList, manufacturerIdList)
      } catch (error) {
        handleResponseError(error)
      }
    },
    async getRecyclingReportAllIndex() {
      try {
        const storeIdList = this.selectedStore.map(store => store.technical_id)
        let manufacturerIdList = []
        if (this.selectedManufacturer.length > 0) {
          manufacturerIdList = this.selectedManufacturer.map(manufacturer => manufacturer.technical_id)
        }

        this.reportAllIndexObject = await RecyclingFolderService.getRecyclingFolderReportAllIndex(
          storeIdList,
          manufacturerIdList)
      } catch (error) {
        handleResponseError(error)
      }
    },
    repairImpactTotal() {
      if (this.reportObject) {
        const total = this.reportObject.lastYearCount.repaired.ecosystemImpactMaterialCount
          + this.reportObject.lastYearCount.repaired.ademeImpactMaterialCount
        if (total > 0) {
          return total.toFixed(2)
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    repairCo2Total() {
      if (this.reportObject) {
        const total = this.reportObject.lastYearCount.repaired.ecosystemImpactCo2Count
          + this.reportObject.lastYearCount.repaired.ademeImpactCo2Count
        if (total > 0) {
          return total.toFixed(2)
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    lastYearImpactTotal() {
      if (this.reportObject) {
        const total = this.reportObject.lastYearCount.repaired.ecosystemImpactMaterialCount
          + this.reportObject.lastYearCount.repaired.ademeImpactMaterialCount
        // Ne pas mettre les impacts des dossiers other pour le moment.
        // + this.reportObject.lastYearCount.other.ecosystemImpactMaterialCount
        // + this.reportObject.lastYearCount.other.ademeImpactMaterialCount
        if (total > 0) {
          return total.toFixed(2)
        } else {
          return 0
        }
      } else {
        return 0
      }
    },
    lastYearCo2Total() {
      if (this.reportObject) {
        const total = this.reportObject.lastYearCount.repaired.ecosystemImpactCo2Count
          + this.reportObject.lastYearCount.repaired.ademeImpactCo2Count
        // Ne pas mettre les impacts des dossiers other pour le moment.
        // + this.reportObject.lastYearCount.other.ecosystemImpactCo2Count
        // + this.reportObject.lastYearCount.other.ademeImpactCo2Count
        if (total > 0) {
          return total.toFixed(2)
        } else {
          return 0
        }
      } else {
        return 0
      }
    }
  }
}
</script>

<template>
  <v-container fluid>
    <div class="d-flex flex-column flex-md-row justify-space-between">
      <h1>{{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.TITLE') }}</h1>
    </div>

    <v-card class="rounded-xl mt-4 d-flex-column" :border="false" :elevation="0">
      <v-row>
        <!--GREEN PART-->
        <v-col cols="12" md="3" class="d-flex flex-column justify-center green-container">
          <!--TITLE-->
          <v-row>
            <v-col class="d-flex flex-column align-start justify-start">
              <h2 class="white-text bold">
                {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.GREEN.TITLE') }}
              </h2>
              <p class="white-text">
                {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.GREEN.TEXT_1') }}
              </p>
            </v-col>
          </v-row>

          <v-row>
            <v-col class="d-flex flex-column align-start justify-end">
              <p class="white-text">
                {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.GREEN.DESCRIPTION') }}
              </p>
              <p class="white-text text-decoration-underline">
                {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.GREEN.LINK_1') }}
              </p>
              <p class="white-text text-decoration-underline">
                {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.GREEN.LINK_2') }}
              </p>
              <p class="white-text text-decoration-underline">
                {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.GREEN.LINK_3') }}
              </p>
              <p class="white-text text-decoration-underline">
                {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.GREEN.LINK_4') }}
              </p>
            </v-col>
          </v-row>
        </v-col>

        <!--MAIN PART-->
        <v-col cols="12" md="9" class="main-container">
          <!--BUTTON-->
          <v-row>
            <v-col class="d-flex flex-row align-center justify-end" style="margin-bottom: 20px">
              <v-btn
                class="boom-button"
                variant="outlined"
                v-if="checkPermission(['DISTRIBUTOR_RECYCLING_READ'])"
                disabled
              >
                <v-icon icon="mdi-recycle" class="ml-2" />
                {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.BUTTON.DOWNLOAD_REPORT') }}
              </v-btn>
            </v-col>
          </v-row>

          <!--REPORT-->
          <v-row class="report-container">
            <v-col cols="12" md="4">
              <v-card class="rounded-xl d-flex-column" :border="false" :elevation="1">
                <v-row>
                  <v-col cols="12" md="6">
                    <p>{{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.REPORT.WORLD_TOUR_TITLE') }}</p>
                    <h3 class="bold xx-large">-</h3>
                  </v-col>
                  <v-col cols="12" md="6" class="d-flex flex-row align-center justify-end">
                    <div class="img-container">
                      <img src="@/assets/images/around_world.svg" alt="logo recycling" />
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card class="rounded-xl d-flex-column" :border="false" :elevation="1">
                <v-row>
                  <v-col cols="12" md="6">
                    <p>{{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.REPORT.CO2') }}</p>
                    <h3 v-if="reportAllIndexObject" class="bold xx-large">
                      {{ reportAllIndexObject.impactCo2Count }} kg
                    </h3>
                    <h3 v-else class="bold xx-large">- kg</h3>
                  </v-col>
                  <v-col cols="12" md="6" class="d-flex flex-row align-center justify-end">
                    <div class="img-container">
                      <img src="@/assets/images/clouds.svg" alt="logo recycling" />
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <v-col cols="12" md="4">
              <v-card class="rounded-xl d-flex-column" :border="false" :elevation="1">
                <v-row>
                  <v-col cols="12" md="6">
                    <p>{{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.REPORT.MATERIALS') }}</p>
                    <h3 v-if="reportAllIndexObject" class="bold xx-large">
                      {{ (reportAllIndexObject.impactMaterialCount / 1000).toFixed(2) }} t
                    </h3>
                    <h3 v-else class="bold xx-large">- K</h3>
                  </v-col>
                  <v-col cols="12" md="6" class="d-flex flex-row align-center justify-end">
                    <div class="img-container">
                      <img src="@/assets/images/rock.svg" alt="logo recycling" />
                    </div>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <!-- FILTER -->
          <v-row class="filter-container">
            <!--Store filter-->
            <v-col cols="12" md="4">
              <v-autocomplete
                id="select"
                v-model="selectedStore"
                :items="storeList"
                :disabled="!storeList.length"
                :placeholder="$t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.SELECT.STORE')"
                multiple
                clearable
                item-title="name"
                item-value="technical_id"
                return-object
                required
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip size="small" v-if="index < 1">
                    <span>{{ item.title }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="text-grey text-caption align-self-center">
                      (+{{ selectedStore.length - 1 }} {{
                      selectedStore.length - 1 === 1 ?
                        $t('COMMON.TABLE.OTHER') : $t('COMMON.TABLE.OTHERS')
                    }})
                    </span>
                </template>
                <template v-slot:item="{ item, props }">
                  <v-list-item
                    :title="item.title"
                    :value="item.value"
                    v-bind="props"
                  >
                    <v-tooltip
                      v-if="shouldShowTooltip(item, 'select')"
                      activator="parent"
                      location="bottom left"
                    >
                      {{ item.title }}
                    </v-tooltip>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <!--Manufacturer filter-->
            <v-col cols="12" md="4">
              <v-autocomplete
                id="select-manufacturer"
                v-model="selectedManufacturer"
                :items="manufacturerList"
                :disabled="selectedStore === null || manufacturerList.length === 0"
                :placeholder="$t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.SELECT.MANUFACTURER')"
                hide-details
                multiple
                clearable
                item-title="name"
                item-value="technical_id"
                return-object
              >
                <template v-slot:selection="{ item, index }">
                  <v-chip size="small" v-if="index < 1">
                    <span>{{ item.title }}</span>
                  </v-chip>
                  <span v-if="index === 1" class="text-grey text-caption align-self-center">
                      (+{{ selectedManufacturer.length - 1 }} {{
                      selectedManufacturer.length - 1 === 1 ?
                        $t('COMMON.TABLE.OTHER') : $t('COMMON.TABLE.OTHERS')
                    }})
                    </span>
                </template>
                <template v-slot:item="{ item, props }">
                  <v-list-item
                    :title="item.title"
                    :value="item.value"
                    v-bind="props"
                  >
                    <v-tooltip
                      v-if="shouldShowTooltip(item, 'select-manufacturer')"
                      activator="parent"
                      location="bottom left"
                    >
                      {{ item.title }}
                    </v-tooltip>
                  </v-list-item>
                </template>
              </v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
            </v-col>
          </v-row>

          <!-- TABLE -->
          <!--Header Row-->
          <v-row>
            <v-col cols="12" md="4"></v-col>
            <v-col cols="12" md="2" class="bold background-grey">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.HEADER.CURRENT_YEAR') }}
            </v-col>
            <v-col cols="12" md="1">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.HEADER.LAST_YEAR') }}
            </v-col>
            <v-col cols="12" md="1">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.HEADER.TWO_YEAR') }}
            </v-col>
            <v-col cols="12" md="2">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.HEADER.IMPACT_MATERIAL') }}
            </v-col>
            <v-col cols="12" md="2">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.HEADER.CO2_IMPACT') }}
            </v-col>
          </v-row>

          <!--Repair Row-->
          <v-row>
            <v-col cols="12" md="4" class="bold background-grey">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.REPAIR_ROW') }}
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span v-if="reportObject" class="bold">
                {{
                  reportObject.currentYearCount.repaired.ecosystemBoomerangCount
                  + reportObject.currentYearCount.repaired.ademeOtherCount
                  + reportObject.currentYearCount.repaired.withoutEvaluationCount
                }}
              </span>
              <span v-else class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="background-grey text-center">
              <span v-if="reportObject">
                {{
                  reportObject.lastYearCount.repaired.ecosystemBoomerangCount
                  + reportObject.lastYearCount.repaired.ademeOtherCount
                  + reportObject.lastYearCount.repaired.withoutEvaluationCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="background-grey text-center">
              <span v-if="reportObject">
                {{
                  reportObject.twoYearsAgoCount.repaired.ecosystemBoomerangCount
                  + reportObject.twoYearsAgoCount.repaired.ademeOtherCount
                  + reportObject.twoYearsAgoCount.repaired.withoutEvaluationCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span v-if="reportObject">
                {{ repairImpactTotal() }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span v-if="reportObject">
                {{ repairCo2Total() }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
          </v-row>

          <!--Repair Ecosystem Row-->
          <v-row>
            <v-col cols="12" md="4">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.REPAIR_ECOSYSTEM_ROW') }}
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span v-if="reportObject" class="bold">
                {{
                  reportObject.currentYearCount.repaired.ecosystemBoomerangCount
                }}
              </span>
              <span v-else class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span v-if="reportObject">
                {{
                  reportObject.lastYearCount.repaired.ecosystemBoomerangCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span v-if="reportObject">
                {{
                  reportObject.twoYearsAgoCount.repaired.ecosystemBoomerangCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <span v-if="reportObject && reportObject.lastYearCount.repaired.ecosystemImpactMaterialCount === 0">
                {{
                  reportObject.lastYearCount.repaired.ecosystemImpactMaterialCount
                }}
              </span>
              <span v-else-if="reportObject && reportObject.lastYearCount.repaired.ecosystemImpactMaterialCount > 0">
                {{
                  reportObject.lastYearCount.repaired.ecosystemImpactMaterialCount.toFixed(2)
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <span v-if="reportObject && reportObject.lastYearCount.repaired.ecosystemImpactCo2Count === 0">
                {{
                  reportObject.lastYearCount.repaired.ecosystemImpactCo2Count
                }}
              </span>
              <span v-else-if="reportObject && reportObject.lastYearCount.repaired.ecosystemImpactCo2Count > 0">
                {{
                  reportObject.lastYearCount.repaired.ecosystemImpactCo2Count.toFixed(2)
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
          </v-row>

          <!--Repair Proxy Row-->
          <v-row>
            <v-col cols="12" md="4">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.REPAIR_PROXY_ROW') }}
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span v-if="reportObject" class="bold">
                {{
                  reportObject.currentYearCount.repaired.ademeOtherCount
                }}
              </span>
              <span v-else class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span v-if="reportObject">
                {{
                  reportObject.lastYearCount.repaired.ademeOtherCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span v-if="reportObject">
                {{
                  reportObject.twoYearsAgoCount.repaired.ademeOtherCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <span v-if="reportObject && reportObject.lastYearCount.repaired.ademeImpactMaterialCount === 0">
                {{
                  reportObject.lastYearCount.repaired.ademeImpactMaterialCount
                }}
              </span>
              <span v-else-if="reportObject && reportObject.lastYearCount.repaired.ademeImpactMaterialCount > 0">
                {{
                  reportObject.lastYearCount.repaired.ademeImpactMaterialCount.toFixed(2)
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <span v-if="reportObject && reportObject.lastYearCount.repaired.ademeImpactCo2Count === 0">
                {{
                  reportObject.lastYearCount.repaired.ademeImpactCo2Count
                }}
              </span>
              <span v-else-if="reportObject && reportObject.lastYearCount.repaired.ademeImpactCo2Count > 0">
                {{
                  reportObject.lastYearCount.repaired.ademeImpactCo2Count.toFixed(2)
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
          </v-row>

          <!--Repair Without studies Row-->
          <v-row>
            <v-col cols="12" md="4">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.REPAIR_WITHOUT_ROW') }}
            </v-col>
            <v-col cols="12" md="2" class="bold background-grey text-center">
              <span v-if="reportObject" class="bold">
                {{
                  reportObject.currentYearCount.repaired.withoutEvaluationCount
                }}
              </span>
              <span v-else class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span v-if="reportObject">
                {{
                  reportObject.lastYearCount.repaired.withoutEvaluationCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span v-if="reportObject">
                {{
                  reportObject.twoYearsAgoCount.repaired.withoutEvaluationCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <span>
                -
              </span>
            </v-col>
          </v-row>

          <!--Reuse Row-->
          <v-row>
            <v-col cols="12" md="4" class="bold background-grey">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.REUSE_ROW') }}
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="background-grey text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="background-grey text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span>
                -
              </span>
            </v-col>
          </v-row>

          <!--Reuse Ecosystem Row-->
          <v-row>
            <v-col cols="12" md="4">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.REUSE_ECOSYSTEM_ROW') }}
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <span>
                -
              </span>
            </v-col>
          </v-row>

          <!--Reuse Proxy Row-->
          <v-row>
            <v-col cols="12" md="4">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.REUSE_PROXY_ROW') }}
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <span>
                -
              </span>
            </v-col>
          </v-row>

          <!--Reuse Without studies Row-->
          <v-row>
            <v-col cols="12" md="4">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.REUSE_WITHOUT_ROW') }}
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="text-center">
              <span>
                -
              </span>
            </v-col>
          </v-row>

          <!--Recycled Row-->
          <v-row>
            <v-col cols="12" md="4" class="bold background-grey">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.RECYCLED_ROW') }}
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span v-if="reportObject" class="bold">
                {{
                  reportObject.currentYearCount.recycledByBoomerangCount
                  + reportObject.currentYearCount.recycledByRepairerCount
                }}
              </span>
              <span v-else class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="background-grey text-center">
              <span v-if="reportObject">
                {{
                  reportObject.lastYearCount.recycledByBoomerangCount
                  + reportObject.lastYearCount.recycledByRepairerCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="background-grey text-center">
              <span v-if="reportObject">
                {{
                  reportObject.twoYearsAgoCount.recycledByBoomerangCount
                  + reportObject.twoYearsAgoCount.recycledByRepairerCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
            </v-col>
          </v-row>

          <!--Recycled by boomerang Row-->
          <v-row>
            <v-col cols="12" md="4">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.RECYCLED_BY_BOOMERANG_ROW') }}
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span v-if="reportObject" class="bold">
                {{
                  reportObject.currentYearCount.recycledByBoomerangCount
                }}
              </span>
              <span v-else class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span v-if="reportObject">
                {{
                  reportObject.lastYearCount.recycledByBoomerangCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span v-if="reportObject">
                {{
                  reportObject.twoYearsAgoCount.recycledByBoomerangCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2"></v-col>
            <v-col cols="12" md="2"></v-col>
          </v-row>

          <!--Recycled by repairer Row-->
          <v-row>
            <v-col cols="12" md="4">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.RECYCLED_BY_REPAIRER_ROW') }}
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span v-if="reportObject" class="bold">
                {{
                  reportObject.currentYearCount.recycledByRepairerCount
                }}
              </span>
              <span v-else class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span v-if="reportObject">
                {{
                  reportObject.lastYearCount.recycledByRepairerCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="text-center">
              <span v-if="reportObject">
                {{
                  reportObject.twoYearsAgoCount.recycledByRepairerCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2"></v-col>
            <v-col cols="12" md="2"></v-col>
          </v-row>

          <!--Rental Row-->
          <v-row>
            <v-col cols="12" md="4" class="bold background-grey">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.RENTAL_ROW') }}
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="background-grey text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="background-grey text-center">
              <span>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center"></v-col>
            <v-col cols="12" md="2" class="background-grey text-center"></v-col>
          </v-row>

          <!--Without information Row-->
          <v-row>
            <v-col cols="12" md="4" class="bold background-grey">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.WITHOUT_INFORMATION_ROW') }}
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center">
              <span v-if="reportObject" class="bold">
                {{
                  reportObject.currentYearCount.other.ecosystemBoomerangCount
                  + reportObject.currentYearCount.other.ademeOtherCount
                  + reportObject.currentYearCount.other.withoutEvaluationCount
                }}
              </span>
              <span v-else class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="background-grey text-center">
              <span v-if="reportObject">
                {{
                  reportObject.lastYearCount.other.ecosystemBoomerangCount
                  + reportObject.lastYearCount.other.ademeOtherCount
                  + reportObject.lastYearCount.other.withoutEvaluationCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="background-grey text-center">
              <span v-if="reportObject">
                {{
                  reportObject.twoYearsAgoCount.other.ecosystemBoomerangCount
                  + reportObject.twoYearsAgoCount.other.ademeOtherCount
                  + reportObject.twoYearsAgoCount.other.withoutEvaluationCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="background-grey text-center"></v-col>
            <v-col cols="12" md="2" class="background-grey text-center"></v-col>
          </v-row>

          <!--Total Row-->
          <v-row>
            <v-col cols="12" md="4" class="bold background-green white-text">
              {{ $t('RECYCLING_MODULE.RECYCLING_REPORT_PAGE.MAIN.TABLE.TOTAL') }}
            </v-col>
            <v-col cols="12" md="2" class="background-green white-text text-center">
              <span v-if="reportObject" class="bold">
                {{
                  reportObject.currentYearCount.repaired.ecosystemBoomerangCount
                  + reportObject.currentYearCount.repaired.ademeOtherCount
                  + reportObject.currentYearCount.repaired.withoutEvaluationCount
                  + reportObject.currentYearCount.recycledByRepairerCount
                  + reportObject.currentYearCount.recycledByBoomerangCount
                  + reportObject.currentYearCount.other.ecosystemBoomerangCount
                  + reportObject.currentYearCount.other.ademeOtherCount
                  + reportObject.currentYearCount.other.withoutEvaluationCount
                }}
              </span>
              <span v-else class="bold">
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="bold background-green white-text text-center">
              <span v-if="reportObject">
                {{
                  reportObject.lastYearCount.repaired.ecosystemBoomerangCount
                  + reportObject.lastYearCount.repaired.ademeOtherCount
                  + reportObject.lastYearCount.repaired.withoutEvaluationCount
                  + reportObject.lastYearCount.recycledByRepairerCount
                  + reportObject.lastYearCount.recycledByBoomerangCount
                  + reportObject.lastYearCount.other.ecosystemBoomerangCount
                  + reportObject.lastYearCount.other.ademeOtherCount
                  + reportObject.lastYearCount.other.withoutEvaluationCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="1" class="bold background-green white-text text-center">
              <span v-if="reportObject">
                {{
                  reportObject.twoYearsAgoCount.repaired.ecosystemBoomerangCount
                  + reportObject.twoYearsAgoCount.repaired.ademeOtherCount
                  + reportObject.twoYearsAgoCount.repaired.withoutEvaluationCount
                  + reportObject.twoYearsAgoCount.recycledByRepairerCount
                  + reportObject.twoYearsAgoCount.recycledByBoomerangCount
                  + reportObject.twoYearsAgoCount.other.ecosystemBoomerangCount
                  + reportObject.twoYearsAgoCount.other.ademeOtherCount
                  + reportObject.twoYearsAgoCount.other.withoutEvaluationCount
                }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="bold background-green white-text text-center">
              <span v-if="reportObject">
                {{ lastYearImpactTotal() }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
            <v-col cols="12" md="2" class="bold background-green white-text text-center">
              <span v-if="reportObject">
                {{ lastYearCo2Total() }}
              </span>
              <span v-else>
                -
              </span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card>
  </v-container>

  <SelectStoreModal ref="selectStoreModal" />
</template>

<style scoped>
.v-container {
  padding: 32px;
}

.v-card {
  padding: 20px 5px 20px 20px;
}

.bold {
  font-weight: bold;
}

.background-grey {
  background-color: #efefef;
}

.background-green {
  background-color: #559a1b;
}

.white-text {
  color: white;
}

.xx-large {
  font-size: xx-large;
}

.green-container {
  background-color: #165039;
  margin: -10px 0 -10px -10px;
  padding: 20px 10px 20px 20px;
}

.main-container {
  padding: 10px 15px 10px 30px;

  .report-container {
    .v-card {
      padding: 20px;
      min-height: 100%;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
      align-items: center;
    }

    .img-container {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: center;
      align-items: center;
      background-color: #efefef;
      border-radius: 20px;
      padding: 20px;
      width: 85px;
      height: 85px;
    }
  }

  .logo {
    max-width: 150px;
    max-height: 80px;
  }

  .custom-td {
    padding: 0 2px !important;
  }

}
</style>
